import styled from "@emotion/styled";
import Box from "@mui/material/Box";
import { CUSTOMER_SERVICES_CENTRE } from "shared/routes/paths";

export const StyledMain = styled(Box, {
  shouldForwardProp: (propName) => !["pathname"].includes(propName),
})<{
  pathname: string;
}>`
  position: relative;
  padding: ${({ pathname }) =>
    pathname === CUSTOMER_SERVICES_CENTRE ? "0" : "1.5rem"};
  min-height: calc(100vh - 3rem);
  width: 100%;
  overflow-x: hidden;

  &:has(.grid-page-layout) {
    padding: 1.5rem 0;
  }
`;
